import moment from 'moment';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DATE_FORMATS = {
  YMD_HMS: 'YYYY-MM-DD HH:mm:ss',
  YMD_HMS_NEW: 'DD/MM/YYYY HH:mm:ss',
  YMD: 'YYYY-MM-DD',
};

function formatWithPattern(value: any, pattern: string): any {
  const parsed = new Date(value);
  if (value && parsed) {
    let formatted = moment(value).format(pattern);
    if (formatted.length > pattern.length) {
      formatted = formatted.substring(0, pattern.length).replace('T', ' ');
    }
    return formatted;
  }
  return value;
}

function createDateFormatter(pattern: string) {
  return (value: any) => formatWithPattern(value, pattern);
}

export const DateUtil = {
  formatDate: createDateFormatter(DATE_FORMATS.YMD_HMS),
  formatDateYMD: createDateFormatter(DATE_FORMATS.YMD),
  formatDateNew: createDateFormatter(DATE_FORMATS.YMD_HMS_NEW),

  formatLocalDateToUtcString(
    date: Date | string,
    endOfDay: boolean = false
  ): string | null {
    if (!date) {
      return null;
    }
    if (
      typeof date === 'string' &&
      /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(date)
    ) {
      return date;
    }
    const local = new Date(date);
    if (Number.isNaN(local.getTime())) {
      return null;
    }
    if (endOfDay) {
      local.setHours(23, 59, 59, 0);
    } else {
      local.setHours(0, 0, 0, 0);
    }
    const Y = local.getUTCFullYear();
    const M = String(local.getUTCMonth() + 1).padStart(2, '0');
    const D = String(local.getUTCDate()).padStart(2, '0');
    const h = String(local.getUTCHours()).padStart(2, '0');
    const m = String(local.getUTCMinutes()).padStart(2, '0');
    const s = String(local.getUTCSeconds()).padStart(2, '0');
    return `${Y}-${M}-${D} ${h}:${m}:${s}.000`;
  },
};
